import { Users, Stethoscope } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AppHeader } from "@/components/AppHeader";
import { PatientManager } from "@/components/PatientManager";
import { TeamManager } from "@/components/TeamManager";
import { WebhookConfigDialog } from "@/components/WebhookConfigDialog";

export default function ClinicAdminDashboard() {
  return (
    <div className="max-w-4xl mx-auto px-4 pb-24">
      <AppHeader><WebhookConfigDialog /></AppHeader>
      <div className="flex items-center gap-2 text-brand-teal text-xs font-bold uppercase tracking-[0.2em] mb-3">
        <Stethoscope className="w-4 h-4" /> Administración de clínica
      </div>
      <Tabs defaultValue="pacientes" className="w-full">
        <TabsList className="mb-5">
          <TabsTrigger value="pacientes" data-testid="tab-pacientes"><Users className="w-4 h-4 mr-1" /> Pacientes</TabsTrigger>
          <TabsTrigger value="equipo" data-testid="tab-equipo"><Users className="w-4 h-4 mr-1" /> Equipo</TabsTrigger>
        </TabsList>
        <TabsContent value="pacientes"><PatientManager /></TabsContent>
        <TabsContent value="equipo"><TeamManager roles={["therapist"]} title="Terapeutas" /></TabsContent>
      </Tabs>
    </div>
  );
}
